<template>
<main-content>
    <kt-panel>
        <kt-panel-body v-if="ip_location !== 'IR'">
            <div class="alert alert-danger" role="alert">
                {{ $t('label.ir_ip_error') }}
            </div>
        </kt-panel-body>
        <kt-panel-body v-else>
            <gateway-form :form_data="form_data" :submit="submit"></gateway-form>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import GatewayForm from './components/form'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { gatewayService, ipApi } from '@/common/api.service'
import { userTypes } from '@/constants/userTypes';
import { mapGetters } from 'vuex';

export default {
    components: {
        'main-content': mainContent,
        'gateway-form': GatewayForm
    },
    data() {
        return {
            user_types: userTypes,
            ip_location: '',
        }
    },
    computed: {
        form_data: {
            get: function() {
                return this.$store.state.gateway.form_data
            },
            set: function(value) {
                this.$store.commit('gateway/setFormData', value)
            }
        },
        ...mapGetters('user', [
            'current_user'
        ]),
    },
    mounted() {
        ipApi.ipLocation().then(response => {
            this.ip_location = response.data.countryCode;
        })
    },
    methods: {
        submit(e) {
            let form = $('#gateway_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    birth_crtfct_number: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.REAL;
                        },
                    },
                    // birth_crtfct_serial: {
                    //     required: () => {
                    //         return this.current_user.user_type == this.user_types.REAL;
                    //     },
                    // },
                    // birth_crtfct_series_letter: {
                    //     required: () => {
                    //         return this.current_user.user_type == this.user_types.REAL;
                    //     },
                    // },
                    // birth_crtfct_series_number: {
                    //     required: () => {
                    //         return this.current_user.user_type == this.user_types.REAL;
                    //     },
                    // },
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    subcategory_code: {
                        required: true,
                    },
                    address: {
                        required: true,
                    },
                    telephone: {
                        required: true
                    },
                    phone_number: {
                        required: false
                    },
                    logo: {
                        required: true
                    },
                    sheba_number: {
                        required: true
                    },
                    site_address: {
                        required: true,
                        url: true
                    },
                    tax_payer_code: {
                        required:  true,
                        digits:true,
                     maxlength:10,
                     minlength:10,

                    },
                    abroad_ips_only_by_user: {
                        required:  true,
                    },
                    province_code: {
                        required:  true,
                    },
                    city_code: {
                        required:  true,
                    },
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)

            let params = this.$store.getters['gateway/form_data']
            params.merchant_share_percent = 100
            gatewayService.create(params).then(response => {
                this.$store.commit('gateway/reset_payment_helper_shops');
                this.$router.push('/gateways')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.commit('gateway/clearFormData')
        })
    },
}
</script>
